var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedsubmissionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 72,
    viewBox: "0 0 61 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3772 44.3077L46.1243 32.5606L42.2086 28.6449L30.4671 40.392L18.7145 28.6505L14.7988 32.5606L26.5458 44.3077L14.8043 56.0492L18.7145 59.9705L30.4615 48.2234L42.2086 59.9705L46.1243 56.0548L34.3828 44.3077H34.3772ZM47.0769 8.30769H60.9231V72H0V8.30769H13.8462V13.8462H47.0769V8.30769ZM19.3846 8.30769V0H41.5385V8.30769H19.3846Z",
    fill: "#65CC48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedsubmissionsIcon);
export default __webpack_public_path__ + "static/media/failedsubmissions-icon.3ffd4228dfe5a0956ae9457b50006a54.svg";
export { ForwardRef as ReactComponent };